import useDebounceInput from 'customHooks/useDebounceInput'
import { fetchGetSupplyOrderDetailItem } from 'features/SupplyOrder/redux/outboundSODetail'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from 'store'

const useProductDetail = () => {
  const { id } = useParams<{ id: string }>()
  const dispatch = useAppDispatch()

  const [search, handleSearch] = useDebounceInput({
    onChange: (val) => {
      dispatch(
        fetchGetSupplyOrderDetailItem({
          supplyOrderId: Number(id),
          params: {
            pageIndex: 0,
            name: val || undefined,
          },
        }),
      )
    },
  })

  return {
    search,
    handleSearch,
  }
}

export default useProductDetail
